import { NewMatchCardSchema } from '@/views/sports/components/NewMatchCard/styles/NewMatchCard.styles';

export const newMatchCardStyles: NewMatchCardSchema = {
  boxWrapper: {
    borderRadius: 'md',
    boxShadow:
      '0px 0px 0px 1px rgba(255, 255, 255, 0.2) inset, 0px 4px 6px 0px rgba(0, 0, 0, 0.15)',
    overflow: 'hidden',
  },
  bodyStack: {
    p: 2,
    borderTopRadius: 'md',
    m: '1px',
    mb: '0',
    bg: 'rgba(0, 209, 255, 0.25)',
    color: 'gray.700',
    fontWeight: 'bold',
  },
  titleHeading: {
    cursor: 'pointer',
    as: 'h5',
    textTransform: 'uppercase',
    textAlign: 'center',
    fontFamily: 'accent',
    fontSize: 'xs',
    fontWeight: 'semibold',
    color: 'white',
  },
  footerFlex: {
    as: 'footer',
    bg: 'blackAlpha.300',
    boxShadow: '0px -1px 0px 0px rgba(255, 255, 255, 0.10)',
    fontSize: '2xs',
    fontWeight: 'semibold',
    fontFamily: 'accent',
    px: '2',
    py: '1',
    borderTop: '1px',
    borderColor: 'blackAlpha.300',
    m: '1px',
    mt: '0',
    borderBottomRadius: 'md',
    alignItems: 'center',
    gap: '1',
  },
  footerStack: {
    direction: 'row',
  },
  footerStackDivider: {
    height: '2.5',
    borderColor: 'white',
  },
  footerSportNameFlex: {
    align: 'center',
    gap: '1',
    maxW: '85%',
    w: 'fit-content',
    mr: '2',
  },
  footerSportNameIconSvg: {
    color: 'beta.300',
    fontSize: 'md',
  },
  footerCompetitionNameText: {
    sx: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: 'initial',
    },
  },
  footerCountDown: {
    sx: {
      '&&&.state-prior': {
        textTransform: 'uppercase',
      },
    },
    sxWrapper: {
      mr: 'auto',
    },
  },
  footerDuotoneSgmLogo: {
    h: 'auto',
    primaryColor: 'beta.300',
    secondaryColor: 'beta.600',
    w: '10',
  },
  footerMatchLink: {
    alignItems: 'center',
    display: 'flex',
    lineHeight: 'initial',
    fontWeight: 'normal',
  },
  footerMatchLinkIcon: {
    color: 'beta.300',
    fontSize: 'md',
  },
};
